"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledgeProject.list': 'Projects',
    'route.knowledgeProject.create': 'Add Project',
    'route.knowledgeProject.edit': 'Edit Project',
};
